var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 9.49999C0.75 9.17676 0.878404 8.86676 1.10696 8.6382C1.33552 8.40964 1.64552 8.28124 1.96875 8.28124L16.0892 8.28124L10.8559 3.05037C10.7426 2.93705 10.6527 2.80253 10.5913 2.65448C10.53 2.50642 10.4985 2.34774 10.4985 2.18749C10.4985 2.02724 10.53 1.86856 10.5913 1.7205C10.6527 1.57245 10.7426 1.43793 10.8559 1.32462C10.9692 1.2113 11.1037 1.12142 11.2518 1.06009C11.3998 0.998764 11.5585 0.967201 11.7187 0.967201C11.879 0.967201 12.0377 0.998764 12.1857 1.06009C12.3338 1.12142 12.4683 1.2113 12.5816 1.32462L19.8941 8.63711C20.0076 8.75032 20.0977 8.88482 20.1591 9.03288C20.2205 9.18095 20.2522 9.33968 20.2522 9.49999C20.2522 9.6603 20.2205 9.81903 20.1591 9.9671C20.0977 10.1152 20.0076 10.2497 19.8941 10.3629L12.5816 17.6754C12.4683 17.7887 12.3338 17.8786 12.1857 17.9399C12.0377 18.0012 11.879 18.0328 11.7187 18.0328C11.5585 18.0328 11.3998 18.0012 11.2518 17.9399C11.1037 17.8786 10.9692 17.7887 10.8559 17.6754C10.627 17.4465 10.4985 17.1361 10.4985 16.8125C10.4985 16.6522 10.53 16.4936 10.5913 16.3455C10.6527 16.1974 10.7426 16.0629 10.8559 15.9496L16.0892 10.7187L1.96875 10.7187C1.64552 10.7187 1.33552 10.5903 1.10696 10.3618C0.878404 10.1332 0.75 9.82322 0.75 9.49999Z",
    fill: "#FFEBF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroArrow);
export default __webpack_public_path__ + "static/media/introArrow.4d861d8cced246021ca2cac28b8c19af.svg";
export { ForwardRef as ReactComponent };